export default __webpack_public_path__ + "static/media/company-icon.ca80e385.svg";